<mat-card>
    <mat-card-header>
        <mat-card-title class="popupHeader">
            <div class="mat-card-header-text" i18n>
                Map Settings
              </div> 
        </mat-card-title>
    </mat-card-header>
    
    <mat-card-content>
        <form>
            <mat-form-field class="my-form-field"> 
                <mat-label i18n>WMS Link</mat-label>      
                <input matInput name="wmsLink" [(ngModel)]="wmsLink" [value]="wmsLink" type="text">
            </mat-form-field>

            <mat-form-field class="my-form-field"> 
                <mat-label i18n>Map Cache Id</mat-label>      
                <input matInput name="mapCacheId" [(ngModel)]="mapCacheId" [value]="mapCacheId" type="text">
            </mat-form-field>

            <mat-form-field class="my-form-field"> 
                <mat-label i18n>Map Cache Name</mat-label>      
                <input matInput name="mapCacheName" [(ngModel)]="mapCacheName" [value]="mapCacheName" type="text">
            </mat-form-field>
       
            <mat-form-field class="my-form-field"> 
                <mat-label i18n>SRID</mat-label>      
                <input matInput name="srid" [(ngModel)]="srid" [value]="srid" type="text">
            </mat-form-field>
       
            <mat-form-field class="my-form-field"> 
                <mat-label i18n>MapAttributation</mat-label>      
                <input matInput name="attributation" [(ngModel)]="attributation" [value]="attributation" type="text">
            </mat-form-field>

            <mat-form-field class="my-form-field"> 
                <mat-label i18n>Hostname</mat-label>      
                <input matInput name="domain" [(ngModel)]="domainname" [value]="domainname" type="text">
            </mat-form-field>
        </form>
    </mat-card-content>

    <mat-card-actions>
        <div class="buttonContent">
            <button mat-raised-button type="button" color="primary" (click)="onSave()" i18n>SAVE</button>
        </div>        
    </mat-card-actions>
</mat-card>